let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("6Tuw7"), load("gr9Xf"), load("68WuS")]).then(() => parcelRequire('fUqEj'));